import { render, staticRenderFns } from "./GameGenresSelectBox.vue?vue&type=template&id=dc626ce2&"
import script from "./GameGenresSelectBox.vue?vue&type=script&lang=js&"
export * from "./GameGenresSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./GameGenresSelectBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports